import * as React from "react";

import "./receipt-details.scss";

import {cs} from "@Common/react/chain-services";

export const ReceiptDetails = ({onViewCart, onDenyCart}) => cs(
    () => (
        <div className="receipt-details-91i">
            <div className="title" xd-qa-type="label" xd-qa-name="Receipt Details">
                Receipt Details
            </div>

            {(onViewCart || onDenyCart) && (
                <div className="actions">
                    {onViewCart && (
                        <a onClick={onViewCart} xd-qa-type="link" xd-qa-name="View Cart">View Cart</a>
                    )}

                    {onDenyCart && (
                        <a className="danger" onClick={onDenyCart} xd-qa-type="link" xd-qa-name="Deny Cart">Deny Cart</a>
                    )}
                </div>
            )}
        </div>
    ),
);
